import React from "react";
//#region types
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { WeeklyFormTableHeaderProps } from "models/propTypes/timeReportingPropTypes";
//#endregion
//#region components
import { Grid, TableCell, TableRow } from "@mui/material";
import { Icon } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const WeeklyFormTableHeader: React.FC<WeeklyFormTableHeaderProps> = (props) => {
  const { weekLocks, holidays } = props;
  return (
    <TableRow key={`tab-header`} className={cssExports.formTableHeader}>
      {props.innerFields &&
        Object.entries(props.innerFields).map(([currentFieldName, currentField]) => {
          const widthPercentage =
            currentField?.widthColumnCount && typeof currentField.widthColumnCount === "number"
              ? (currentField.widthColumnCount / 12) * 100
              : undefined;
          const isHoliday =
            currentFieldName === FormFieldConstants.TimeReporting.WeeklyTimeReportRow.Saturday ||
            currentFieldName === FormFieldConstants.TimeReporting.WeeklyTimeReportRow.Sunday ||
            !!(holidays as any)[currentFieldName];
          return (
            currentField &&
            (currentFieldName === FormFieldConstants.TimeReporting.WeeklyTimeReportRow.Type ? (
              <TableCell
                key={`tab-cell-header-icon}`}
                className={clsx(currentField.classes?.formControl, cssExports.titleCell)}
              >
                <Grid container item className={clsx(cssExports.iconField, cssExports.header)}>
                  <Icon icon={IconDefinitionConstants.WMonthCalendar} />
                </Grid>
              </TableCell>
            ) : currentFieldName === FormFieldConstants.TimeReporting.WeeklyTimeReportRow.Name ? (
              <TableCell
                key={`tab-cell-header-name}`}
                className={clsx(currentField.classes?.formControl, cssExports.titleCell)}
              >
                {currentField.controlLabel}
              </TableCell>
            ) : (
              <TableCell
                key={`tab-cell-header-${currentFieldName}`}
                className={clsx(
                  currentField.classes?.formControl,
                  cssExports.dayCell,
                  isHoliday ? cssExports.weekEnd : ""
                )}
                style={{
                  width: `${widthPercentage}%`,
                }}
              >
                {currentField.controlLabel && (
                  <Grid container justifyContent={"flex-end"} direction={"row"}>
                    <Grid item>
                      <Grid container direction={"column"} spacing={1}>
                        {weekLocks && (weekLocks as any)[currentFieldName] && (
                          <Grid item container justifyContent={"center"}>
                            <Icon icon={IconDefinitionConstants.WLock} className={cssExports.inputIcon} />
                          </Grid>
                        )}
                        <Grid item>{currentField.controlLabel}</Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </TableCell>
            ))
          );
        })}
      <TableCell key={`tab-cell-header-last`} className={clsx(cssExports.editableTableActionButton)}></TableCell>
    </TableRow>
  );
};
export default WeeklyFormTableHeader;
